import {Actions, createEffect, ofType, ROOT_EFFECTS_INIT} from '@ngrx/effects';
import {SupportedCountryApi} from '@modules/supported-country/api/supported-country.api';
import {catchError, of, switchMap, tap} from 'rxjs';
import {Injectable} from '@angular/core';
import {SupportedCountryService} from "@modules/supported-country/services/supported-country.service";

@Injectable()
export class SupportedCountryInitializerEffects {
  initSupportedCountries$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => this.supportedCountryApi.get$()),
      tap(entities => this.supportedCountryService.dispatchSetEntities(entities)),
      catchError(e => {
        console.error(e);

        return of(this.supportedCountryService.entityStore.clearEntitiesAction());
      }),
    )
  }, {dispatch: false});

  constructor(
    protected readonly actions$: Actions,
    protected readonly supportedCountryApi: SupportedCountryApi,
    protected readonly supportedCountryService: SupportedCountryService
  ) {
  }
}
